import { GridSchema, IRow, TableColum } from "../../interfaces";
import { GridEditableState } from "../GridEditable";
import { getValues, uid } from "../../../../helpers/Utils";

export const getColumnFields = (columns: GridSchema["columns"]) =>
	columns?.reduce((acc, _column) => {
		acc[_column.field] = null;

		return acc;
	}, {});

export const createRows = (values, columns = [], dependenceLength = 0): IRow => {
	if (!Array.isArray(values)) {
		return {};
	}
	// Only groups !!!
	const _groupFields = getColumnFields(columns ?? []);
	const templateColumns =
		dependenceLength &&
		Array.from({ length: dependenceLength }, () => ({
			..._groupFields,
			key: `stage_${uid()}`,
		}));

	return values?.reduce((acc, value) => {
		if (dependenceLength) {
			const _groups = Array.isArray(value.groups) ? [...value.groups] : [];

			if (dependenceLength > _groups.length) {
				value.groups = [..._groups, ...templateColumns];
				value.groups.length = dependenceLength;
			}

			if (dependenceLength < _groups.length && dependenceLength !== 0) {
				value.groups.length = dependenceLength;
			}
		}

		if (dependenceLength === 0 || !dependenceLength) {
			value.groups = null;
		}

		acc[value.key] = { ...value, isEdit: false };

		return acc;
	}, {});
};

export const createHeaderCols = (
	columns: Array<TableColum>,
	template?: GridSchema["template"]
): GridEditableState["columns"] & { groups?: GridEditableState["columns"] } => {
	if (!Array.isArray(columns)) {
		return {};
	}

	const colHeaders = columns?.reduce(
		(acc, value) => {
			acc[value.field] = value;

			return acc;
		},
		{ groups: null }
	);

	if (template?.columns) {
		const templates = template.columns.reduce((acc, _template) => {
			acc[_template.field] = _template;
			return acc;
		}, {});

		colHeaders.groups = { ...templates };
	} else {
		delete colHeaders.groups;
	}

	return colHeaders;
};

export const isExistEdit = (rows: IRow): boolean => getValues(rows)?.some((row) => row.isEdit);
